export const powerbiTypes = {
    REPORT_STATUS_LOADING: "REPORT_STATUS_LOADING",
    REPORT_STATUS_RENDERED: "REPORT_STATUS_RENDERED",
}